import React from "react";

const WareHouseStock = () => {
  return <div>Warehouse stock</div>;
};

export default WareHouseStock;
